export function countStatus(arr: Array<any>) {
  return arr.reduce(
    (result: any, item: any) => {
      const { eRequestStatus } = item;

      if (result.hasOwnProperty(eRequestStatus)) {
        result[eRequestStatus]++;
      } else {
        result[eRequestStatus] = 1;
      }

      result.total++;
      return result;
    },
    { total: 0 }
  );
}
